class subNavModule {
    constructor(selector) {
        this.selector = selector;
        this.subnavs = document.querySelectorAll(selector);
        this.initSubNav();
    }

    initSubNav() {
        this.subnavs.forEach(subnav => {
            const toggleElement = subnav.querySelector('[data-sub-nav-toggle]');
            if (toggleElement) {
                toggleElement.addEventListener('click', (event) => {
                    const bodyHasClass = document.body.classList.contains('js-header--open');                    
                    if (bodyHasClass) {
                        event.preventDefault();
                    }                    
                    subnav.classList.toggle('js-sub-nav--open');
                });
            }
        });
    }
}

export default subNavModule;